module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/food-icon-819580f428ea021f6ecbf2f7ce8d9ce3.png";